import { useMemo } from "react";

export const useMinInputWidth = (str: string) => {
  return useMemo(() => {
    return str.length * 8 + 16;
  }, [str.length]);
};
